import { themeType } from 'lib/types/theme';

export const lightTheme: themeType = {
	background: '#fafafa',
	text: '#111517',
	element: '#ffffff',
	input: '#858585',
};

export const darkTheme: themeType = {
	background: '#202c37',
	text: '#ffffff',
	element: '#2b3945',
	input: '#858585',
};
